export const VIDEO_URL =
  "https://nationaleagleresearch-public-assets.s3.amazonaws.com/home_video/national-eagle-research-overview.mp4";
export const POSTER_URL =
  "https://nationaleagleresearch-public-assets.s3.amazonaws.com/home_video/national-eagle-research-overview-poster.jpg";
